import React from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { Card, Typography, Divider, Grid, IconButton } from '@material-ui/core';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';

const useStyles = makeStyles(theme => ({
  card: {
    display: 'flex',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
  },
  addpadding: {
    padding: '8px'
  },

  classroom: {
    background: theme.palette.primary.main,
    color: 'white',
    flex: '0 0 auto',
    textAlign: 'center',
  },
  times: {
    flex: '0 0 auto'
  },
  entry: {
    flex: '1 1 auto'
  },
  actions: {
    flex: '0 0 auto',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },

  content: {
    flex: '1 0 auto',
  },
  cover: {
    width: 151,
  },
  controls: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  playIcon: {
    height: 38,
    width: 38,
  },
}));

const DayCard = (props) => {
  const classes = useStyles();

  const { day, onEdit, onDelete } = props;

  return (
    <Grid key={day.id} item xs={12} md={6} >
      <Card className={classes.card}>

        <div className={classes.classroom + ' ' + classes.addpadding}>
          <Typography variant='h3'>{day.classRoom}</Typography>
        </div>
        <div className={classes.times + ' ' + classes.addpadding}>
          <div>
            <Typography>
              {day.startTime}
            </Typography>

          </div>
          <Divider />
          <div>
            <Typography>
              {day.endTime}
            </Typography>
          </div>
        </div>
        <div className={classes.entry + ' ' + classes.addpadding}>
          <Typography>{day.entry}</Typography>
        </div>
        <div className={classes.actions}>
          <IconButton
            size='small'
            onClick={onEdit(day.id)}
          >
            <EditIcon />
          </IconButton>
          <IconButton
            size='small'
            onClick={onDelete(day.id)}
          >
            <DeleteIcon />
          </IconButton>
        </div>
      </Card>
    </Grid>
  )
}

export default DayCard;
